import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@statsbomb/kitbag-components';
import { FormattedMessage } from 'react-intl';

const CODE_TRANSLATIONS = {
  codec_not_supported: (
    <FormattedMessage defaultMessage="Codec not supported" id="3a227" />
  ),
  frame_rate_insufficient: (
    <FormattedMessage defaultMessage="Frame rate insufficient" id="5f787" />
  ),
  frame_rate_unknown: (
    <FormattedMessage defaultMessage="Frame rate unknown" id="c385e" />
  ),
  resolution_insufficient: (
    <FormattedMessage defaultMessage="Resolution insufficient" id="b9fd9" />
  ),
  resolution_unknown: (
    <FormattedMessage defaultMessage="Resolution unknown" id="a0467" />
  ),
  variable_frame_rate: (
    <FormattedMessage
      defaultMessage="Variable frame rate detected"
      id="80adb"
    />
  ),
};

export function TechnicalMetadataWarning({ warning }) {
  return (
    <Typography key={`${warning.code}-warning`} variant="bodyMedium">
      {CODE_TRANSLATIONS[warning.code] || warning.message || warning.code}
    </Typography>
  );
}

TechnicalMetadataWarning.propTypes = {
  warning: PropTypes.shape({
    code: PropTypes.string,
    message: PropTypes.string,
  }).isRequired,
};

export default { TechnicalMetadataWarning };
